import uiFooter from "./footer.vue"
export default uiFooter
